import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import RadioListItem, { RadioListItemProps } from '@components/atoms/radioListItem';

export const StyleCheckboxListItem = styled(RadioListItem)<
  RadioListItemProps & {
    isError?: boolean;
    isAnswer?: boolean;
    isCorrect?: boolean;
    isSubmitted?: boolean;
    isLoading?: boolean;
  }
>(({ theme, checked, isError, isAnswer, isCorrect, isSubmitted, isLoading }) => {
  let borderColor = 'rgba(0, 0, 0, 0.38)';
  let backgroundColor = 'transparent';
  if (isError) {
    borderColor = '#F44336';
    backgroundColor = 'rgba(244, 67, 54, 0.2)';
  } else if (checked && (!isSubmitted || isLoading)) {
    borderColor = theme.palette.primary.main;
    backgroundColor = alpha(theme.palette.primary.main, 0.12);
  } else if ((checked && isCorrect) || isAnswer) {
    borderColor = theme.palette.borderSuccess?.primary || '';
    backgroundColor = theme.palette.backgroundSuccess?.primary || '';
  }

  return `
    border-radius: 4px;
    border: 1px solid ${borderColor};
    margin-bottom: 16px;
    background-color: ${backgroundColor};

    &:last-of-type {
      margin-bottom: 0;
    }

    .MuiListItemButton-root {
      min-height: 65px;
    }
  `;
});
